/**
 * Reviews list: "Ver más" / "Ver menos" pagination. The actual show/hide is
 * done entirely with CSS nth-child rules generated by the section (see
 * reviews-list.liquid) keyed off a data-pages attribute on the grid; this
 * script only ever changes that one attribute. No per-review JS hiding, no
 * looping over blocks — kept deliberately simple.
 */
(function () {
  function initReviewsList(root) {
    var grid = root.querySelector('[ref="grid"]');
    var moreBtn = root.querySelector('[ref="moreBtn"]');
    var lessBtn = root.querySelector('[ref="lessBtn"]');
    if (!grid) return;

    var maxPages = parseInt(grid.getAttribute('data-max-pages'), 10) || 1;

    function currentPage() {
      return parseInt(grid.getAttribute('data-pages'), 10) || 1;
    }

    function update() {
      var page = currentPage();
      if (moreBtn) moreBtn.classList.toggle('reviews-list__btn--is-hidden', page >= maxPages);
      if (lessBtn) lessBtn.classList.toggle('reviews-list__btn--is-hidden', page <= 1);
    }

    update();

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var next = Math.min(currentPage() + 1, maxPages);
        grid.setAttribute('data-pages', String(next));
        update();
      });
    }

    if (lessBtn) {
      lessBtn.addEventListener('click', function () {
        grid.setAttribute('data-pages', '1');
        update();
        if (typeof grid.scrollIntoView === 'function') {
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  var sections = document.querySelectorAll('.reviews-list');
  sections.forEach(initReviewsList);
})();
